import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const POLITICA_PRIVACIDAD = {
	intro: "En Somnus nos comprometemos con la transparencia y el buen uso de la información.",
	uso: "El uso de este sitio y de los portales (estudiante, organización, administración) está sujeto al reglamento interno y a las políticas de privacidad de la institución. Los datos personales se utilizan únicamente para gestionar cursos, matrículas y certificaciones.",
	contacto: "Para consultas sobre reglamento o tratamiento de datos, contacta a la institución a través de los canales oficiales indicados en la página de inicio.",
};

const POLITICA_CALIDAD = {
	intro: "Nuestra OTEC expresa en este documento su compromiso de asegurar la Calidad de Las acciones de capacitación que ejecute, buscando la satisfacción de los Clientes. La Dirección considera esta Política como parte integral de los negocios que emprenda y por ello asegura su difusión, comprensión y cumplimiento en todos los niveles de la organización.",
	principios: [
		"Cumplir con los requisitos acordados con los clientes, con el SENCE y con la legislación vigente.",
		"Asegurar la mejora continua, mediante la participación activa del personal y el desarrollo permanente de sus habilidades.",
		"Asegurar la rentabilidad, a través de la mejora en la eficacia y eficiencia de los procesos, reduciendo los costos de producción y mejorando los ingresos.",
		"Cumplir con los objetivos establecidos para cada uno de las actividades de Capacitación en términos de costo, plazo y calidad.",
		"Asegurar que todos los empleados sean competentes para cumplir con sus obligaciones y responsabilidades y reciban la capacitación adecuada.",
		"Seleccionar y evaluar a proveedores que cumplan con los requisitos de nuestro sistema de calidad.",
		"Proveer los recursos necesarios para el cumplimiento de esta Política y de los Objetivos establecidos.",
	],
};

export default function PoliticasPage() {
	const navigate = useNavigate();
	const [privacidadOpen, setPrivacidadOpen] = useState(false);
	const [calidadOpen, setCalidadOpen] = useState(false);

	useEffect(() => {
		document.title = "Políticas | Somnus";
		return () => { document.title = "Somnus"; };
	}, []);

	return (
		<main className="font-n politicas-page">
			<div className="banner-course ">
                <h4 className="politicas-title">Políticas</h4>
            </div>
			
			<div className="politicas-container">
				<div className="btn-back-container btn-back-politics">
                    <button onClick={() => navigate(-1)}>
                        <i className="ri-arrow-go-back-line d-inline d-md-none"></i><span className="d-none d-md-inline">Volver</span>
                    </button>
                </div>
				
				<p className="politicas-intro">A continuación puedes consultar nuestra Política de Privacidad y Términos y nuestra Política de Calidad. </p>
				<p className="politicas-intro-drop">Haz clic en cada bloque para desplegar la información.</p>
				<div className="politicas-block">
					<button
						type="button"
						className={`politicas-block-toggle ${privacidadOpen ? "open" : ""}`}
						onClick={() => setPrivacidadOpen((o) => !o)}
						aria-expanded={privacidadOpen}
					>
						<span>Política de Privacidad y Términos</span>
						<i className="ri-arrow-down-s-line politicas-block-chevron" aria-hidden />
					</button>
					<div className={`politicas-block-content ${privacidadOpen ? "open" : ""}`}>
						<p>{POLITICA_PRIVACIDAD.intro}</p>
						<p><strong>Uso de la plataforma:</strong> {POLITICA_PRIVACIDAD.uso}</p>
						<p><strong>Contacto:</strong> {POLITICA_PRIVACIDAD.contacto}</p>
					</div>
				</div>

				<div className="politicas-block">
					<button
						type="button"
						className={`politicas-block-toggle ${calidadOpen ? "open" : ""}`}
						onClick={() => setCalidadOpen((o) => !o)}
						aria-expanded={calidadOpen}
					>
						<span>Política de Calidad</span>
						<i className="ri-arrow-down-s-line politicas-block-chevron" aria-hidden />
					</button>
					<div className={`politicas-block-content ${calidadOpen ? "open" : ""}`}>
						<p>{POLITICA_CALIDAD.intro}</p>
						<p><strong>Esta política se fundamenta en los siguientes principios básicos:</strong></p>
						<ul>
							{POLITICA_CALIDAD.principios.map((item, i) => (
								<li key={i}>{item}</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</main>
	);
}
